import {
    MutationResolvers,
    ActiveOrgDisplayNameQuery,
    ActiveOrgDisplayNameDocument as query,
    SharePdfMutation,
    SharePdfDocument as mutation,
} from '../../../../generated/graphql'

const sharePdfCsv: MutationResolvers['sharePdfCsv'] = async (
    _root,
    { displayUrl, smsNumber, emailAddress, messageBody, subject, textHeader, senderName, senderEmail },
    { cache, client },
) => {
    if (!client) {
        throw new Error('Missing ApolloClient context')
    }

    const queryData = cache.readQuery<ActiveOrgDisplayNameQuery>({
        query,
    })

    const displayName = queryData?.activeOrganization?.displayName

    if (!displayName) {
        throw new Error('Missing Active Organization DisplayName')
    }

    const { data: mutationData } = await client.mutate<SharePdfMutation>({
        mutation,
        variables: {
            displayUrl,
            emailAddress,
            smsNumber,
            messageBody,
            displayName,
            subject,
            textHeader,
            senderEmail,
            senderName,
        },
    })

    return (
        (smsNumber ? !!mutationData?.putMessage?.smsSentStatus : true) &&
        (emailAddress ? !!mutationData?.putMessage?.emailSentStatus : true)
    )
}

export default sharePdfCsv
